import { Expose } from "class-transformer";
import { Model } from "./model";

export class AgePreference extends Model {
  @Expose({name:'sixtyPlusPercentage'}) aboveSixtyPercentage : number ;
  @Expose() underFiftyNinePercentage : number ;
  @Expose() underTwelvePercentage : number ;
}
